import React from 'react';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const UkassaOutput = () => {
    return (
        <div className="ukassa-output">
            <ScrollAnimation
                delay={0}
                animateIn="fadeIn"
                offset={300}
                animateOnce={true}
                duration={1}
            >
                <FullWrapper smallPaddings isMargin={false}>
                    <div className="ukassa-output__container">
                        <span className="ukassa-output__title">Вывод</span>
                        <span className="ukassa-output__text">
                            Сейчас мы проверяем десятки гипотез на спринтах и видим положительную
                            динамику. Благодаря слаженной работе нашей команды и команды клиента,
                            взвешенным решениям удалось быстро восстановить показатели небрендового
                            трафика. Цифры говорят о том, что стратегия работает и мы планомерно
                            улучшаем позиции проекта, несмотря на невозможность настроить редиректы
                            со старого трастового домена.
                        </span>
                    </div>
                </FullWrapper>
            </ScrollAnimation>
        </div>
    );
};

export default UkassaOutput;
